// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__pZBT_","map":"style_map__euG39","title":"style_title__fad4_","h4":"style_h4__8n1IW","text":"style_text__BVLIP"};